<template>
  <div>
    <my-header></my-header>
    <div class="back-color">
      <div class="content-box cooperation-banner">
        <div class="content-detail">
          <p class="title">核心建设单位招募</p>
          <p class="text">共管共享共建</p>
          <p class="text">住院医师规范化培训体系，探索住培人才培养新模式</p>
          <button class="btn">立即加入</button>
        </div>
      </div>
    </div>
    <div class="content-box module-1">
      <ul class="tabs" :class="{'top-tabs': topState}">
        <li class="li" :class="{'active': tabIndex === index}" v-for="(item, index) in tabList" :key="index" @click="tabClick(item, index)">
          <div class="border" v-if="index !== 0"></div>
          <span class="span">{{item.name}}</span>
        </li>
      </ul>
      <div class="content-detail">
        <p class="module-title"><span class="i">&lt;</span><span>我们能提供什么</span><span class="i">&gt;</span></p>
        <ul class="list">
          <li class="li" v-for="(item, index) in list" :key="index" :class="{'margin-right': (index + 1) % 3 !== 0, 'margin-bottom': index < 3}">
            <div class="i">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#' + item.icon"></use>
              </svg>
            </div>
            <p class="title">{{item.title}}</p>
            <p class="text">{{item.text}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="content-box module-2">
      <div class="content-detail">
        <p class="module-title"><span class="i">&lt;</span><span>您需要具备什么</span><span class="i">&gt;</span></p>
        <div class="box p1">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-sanjiyiyuanzizhi"></use>
          </svg>
          <div class="title">三级医院资质</div>
        </div>
        <div class="box p2">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-guojiajizhupeijidi"></use>
          </svg>
          <div class="title">国家级住培基地</div>
        </div>
        <div class="box p3">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-a-leyufengxianreaijiaoxue"></use>
          </svg>
          <div class="title">乐于奉献 热爱教学</div>
        </div>
      </div>
    </div>
    <div class="content-box module-3">
      <div class="content-detail">
        <p class="module-title"><span class="i">&lt;</span><span>如何成为核心单位</span><span class="i">&gt;</span></p>
        <div class="box p1">
          <img class="img" src="/static/img/cooperation/qr1.jpg">
          <div class="index">01</div>
          <div class="title">建立联系</div>
          <div class="text">
            <p>扫码添加微信或者</p>
            <p>电联15315145064</p>
          </div>
          <i class="el-icon-sort-up row"></i>
        </div>
        <div class="box p2">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-tijiaocailiao"></use>
          </svg>
          <div class="index">02</div>
          <div class="title">提交材料</div>
          <div class="text">
            <p>线上提交入驻材料</p>
          </div>
          <i class="el-icon-sort-up row"></i>
        </div>
        <div class="box p3">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-zizhishenhe"></use>
          </svg>
          <div class="index">03</div>
          <div class="title">资质审核</div>
          <div class="text">
            <p>1个工作日内完成资质审核</p>
          </div>
          <i class="el-icon-sort-up row"></i>
        </div>
        <div class="box p4">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-zhengshiruzhu"></use>
          </svg>
          <div class="index">04</div>
          <div class="title">正式入驻</div>
          <div class="text">
            <p>提供基地账号，入驻平台</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box module-4">
      <div class="content-detail">
        <p class="module-title"><span class="i">&lt;</span><span>核心单位</span><span class="i">&gt;</span></p>
        <ul class="tabs1">
          <li class="li" :class="{'active': typeIndex === item.id}" v-for="(item, index) in typeList" :key="index" @click="typeClick(item)">
            <span class="span">{{item.name}}</span>
          </li>
        </ul>
        <ul class="hospital-list">
          <li class="li" v-for="(item, index) in hospitalList" :key="index">
            <b class="dot"></b>
            <a :href="item.url?item.url:'javascript:;'" :target="item.url?'_blank':''" class="link"
            @click="goHref(item)"
            :class="{'click': item.clicked==true}">{{item.name}}</a>
          </li>
        </ul>
        <div class="more" v-show="hospitalList.length < allHospitalList.length">
          <button @click="getMore">了解更多<i class="el-icon-arrow-right i1"></i><i class="el-icon-arrow-right i2"></i><i class="el-icon-arrow-right i3"></i></button>
        </div>
        <div class="empty" v-show="!allHospitalList.length">
          <img src="/static/img/empty.png">
          <p>没有更多了~</p>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { officialSiteServer } from '@/api/api'
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
export default {
  name: 'cooperation',
  components: {
    myHeader: myHeader,
    myFooter: myFooter
  },
  data () {
    return {
      tabList: [
        { name: '我们能提供什么', scroll: 640 },
        { name: '您需要具备什么', scroll: 1570 },
        { name: '如何成为核心单位', scroll: 2170 },
        { name: '核心单位', scroll: 2920 }
      ],
      tabIndex: 0,
      typeList: [
        { name: '放射诊断学', id: '0' },
        { name: '放射技术学', id: '2' },
        { name: '超声影像学', id: '1' },
        { name: '核医学', id: '5' },
        { name: '心电学', id: '3' },
        { name: '病理学', id: '4' },
        { name: '内镜学', id: '6' }
      ],
      typeIndex: '0',
      hospitalList: [],
      allHospitalList: [],
      hospitalIndex: 0,
      list: [
        { title: '学习平台', text: '覆盖影像全专业学科 提供定制化教学课程', icon: 'icon-xuexipingtai' },
        { title: '管理平台', text: '贯穿培训考核全流程 强化住培过程化管理', icon: 'icon-guanlipingtai' },
        { title: '课题申报', text: '多基地联合课题申报 打造高水平科研成果', icon: 'icon-ketishenbao' },
        { title: '论文书写', text: '多基地论文撰写指导 学术交流再上新台阶', icon: 'icon-lunwenshuxie' },
        { title: '奖励机制', text: '建立完善的奖励机制 充分调用各方积极性', icon: 'icon-jianglijizhi' },
        { title: '活动机会', text: '构建标准化赛事课程 创造多样化活动机会', icon: 'icon-huodongjihui' }
      ],
      topState: false,
      clicked: false
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.readDetail()
  },
  methods: {
    handleScroll () {
      if (window.scrollY > 555) {
        this.topState = true
      } else {
        this.topState = false
      }
    },
    tabClick (item, index) {
      this.tabIndex = index
      document.documentElement.scrollTop = document.body.scrollTop = item.scroll || 0
    },
    typeClick (item) {
      if (this.typeIndex === item.id) return
      this.typeIndex = item.id
      this.readDetail()
    },
    readDetail () {
      this.allHospitalList = []
      this.hospitalList = []
      officialSiteServer.queryCooperator({
        orgType: this.typeIndex
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          this.allHospitalList = data
          this.hospitalList = data.slice(0, 30)
          this.hospitalIndex = 30
        }
      })
    },
    getMore () {
      if (this.allHospitalList.length > this.hospitalList.length) {
        this.hospitalIndex += 30
        if (this.allHospitalList.length > this.hospitalIndex) {
          this.hospitalList = this.allHospitalList.slice(0, this.hospitalIndex)
        } else {
          this.hospitalList = this.allHospitalList
        }
      }
    },
    goHref (item) {
      this.$set(item, 'clicked', true)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
@media (min-width: 1920px) {
  .cooperation-banner{
    background: url("/static/img/cooperation/cooperation.png") no-repeat;
  }
}
@media (max-width: 1920px) {
  .cooperation-banner{
    background: url("/static/img/cooperation/cooperation1.jpg") no-repeat;
  }
}
.cooperation-banner {
  height: 560px;
  margin: 0 auto;
  background-size: 100% 100%;
  .content-detail {
    height: 560px;
    padding-top: 102px;
    text-align: left;
  }
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 80px;
    line-height: 110px;
    color: #FFFFFF;
    letter-spacing: 7.11px;
    margin-bottom: 26px;
  }
  .text {
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 30px;
    line-height: 42px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    font-weight: 400;
  }
  .btn {
    width: 126px;
    height: 46px;
    line-height: 46px;
    background: #0C59EF;
    border-radius: 4px;
    font-family: SourceHanSansSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 1.42px;
    position: absolute;
    left: 0;
    bottom: 120px;
    cursor: pointer;
  }
}
.module-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 38px;
  color: #000000;
  height: 56px;
  line-height: 56px;
  span {
    display: inline-block;
    vertical-align: top;
  }
  .i {
    color: #0C59EF;
    margin: 0 30px;
    font-size: 42px;
  }
}
.tabs {
  width: 100%;
  position: absolute;
  background-color: #F9F9FA;
  top: 0;
  z-index: 100;
  .li {
    width: 300px;
    height: 64px;
    display: inline-block;
    position: relative;
    cursor: pointer;
  }
  .span {
    display: inline-block;
    height: 64px;
    line-height: 64px;
    font-size: 18px;
    padding: 0 10px;
    border-bottom: 2px solid #F9F9FA;
    font-family: SourceHanSansSC-Medium;
    color: #000000;
  }
  .border {
    position: absolute;
    left: 0;
    top: 20px;
    width: 1px;
    height: 20px;
    background: #D8D8D8;
  }
  .active {
    .span {
      color: #0C59EF;
      border-bottom: 2px solid #0C59EF;
    }
  }
}
.top-tabs {
  position: fixed;
  top: 64px;
}
.module-1 {
  background-color: #F9F9FA;
  padding-bottom: 120px;
  .content-detail {
    padding-top: 176px;
  }
  .list {
    margin-top: 131px;
    .li {
      width: 384px;
      height: 190px;
      background: #FFFFFF;
      border-radius: 16px;
      padding-top: 80px;
      display: inline-block;
      position: relative;
    }
    .i {
      width: 100px;
      height: 100px;
      background: #FFFFFF;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      border-radius: 8px;
      position: absolute;
      z-index: 10;
      left: 142px;
      top: -50px;
      padding-top: 17px;
    }
    .icon {
      width: 65px;
      height: 65px;
    }
    .margin-right {
      margin-right: 24px;
    }
    .margin-bottom {
      margin-bottom: 138px;
    }
    .title {
      line-height: 36px;
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #000000;
      margin-bottom: 14px;
    }
    .text {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
  }
}
.module-2 {
  background-color: #ffffff;
  .content-detail {
    height: 590px;
    padding-top: 116px;
  }
  .box {
    position: absolute;
    top: 252px;
    width: 152px;
    height: 152px;
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 50%;
    padding-top: 42px;
  }
  .icon {
    width: 70px;
    height: 70px;
  }
  .title {
    width: 200px;
    height: 36px;
    position: absolute;
    left: -24px;
    top: 184px;
    line-height: 36px;
    font-family: SourceHanSansSC-Medium;
    font-size: 24px;
    color: #000000;
  }
  .p1 {
    left: 117px;
  }
  .p2 {
    left: 525px;
  }
  .p3 {
    left: 937px;
  }
}
.module-3 {
  background-color: #F6F6FA;
  .content-detail {
    padding-top: 116px;
    height: 749px;
  }
  .box {
    position: absolute;
    top: 280px;
    width: 152px;
    height: 152px;
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 50%;
    padding-top: 45px;
  }
  .img {
    width: 103px;
    height: 103px;
    position: absolute;
    left: 25px;
    top: 25px;
    image-rendering:-moz-crisp-edges;
    image-rendering:-o-crisp-edges;
    image-rendering:-webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode:nearest-neighbor;
  }
  .icon {
    width: 64px;
    height: 64px;
  }
  .index {
    width: 92px;
    height: 119px;
    line-height: 119px;
    position: absolute;
    bottom: -143px;
    left: -32px;
    font-family: SourceHanSansSC-Medium;
    font-size: 80px;
    color: #E2E5F0;
  }
  .title {
    width: 96px;
    height: 36px;
    position: absolute;
    left: 72px;
    bottom: -125px;
    line-height: 36px;
    font-family: SourceHanSansSC-Medium;
    font-size: 24px;
    color: #000000;
  }
  .text {
    display: inline-block;
    position: absolute;
    right: -16px;
    top: 309px;
    font-family: SourceHanSansSC-Regular;
    font-size: 14px;
    color: #666666;
  }
  .row {
    font-size: 50px;
    color: #E2E5F0;
    transform: rotateX(180deg) rotateZ(90deg);
    position: absolute;
    left: 206px;
    top: 50px;
  }
  .p1 {
    left: 59px;
  }
  .p2 {
    left: 369px;
  }
  .p3 {
    left: 679px;
  }
  .p4 {
    left: 989px;
  }
}
.module-4 {
  background-color: #ffffff;
  .content-detail {
    padding-top: 116px;
  }
}
.hospital-list {
  text-align: left;
  .li {
    display: inline-block;
    vertical-align: top;
    width: 540px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: SourceHanSansSC-Regular;
    font-size: 24px;
    color: #000000;
    .dot{
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #666666;
      border-radius: 50%;
      margin-right: 10px;
      position: relative;
      top: -6px;
    }
  }
  .li:nth-child(odd) {
    margin: 0 120px 24px 0;
  }
  .link:link, .link:visited{
    color: #000000;
  }
  .link:hover{
    color: #0C59EF;
  }
  .link.click {color: #0c59ef;}
  }
.tabs1 {
  margin: 81px 0 80px;
  .li {
    width: 156px;
    height: 42px;
    line-height: 42px;
    display: inline-block;
    margin-left: 18px;
    border: 1px solid #D4D4D4;
    border-radius: 4px;
    font-family: SourceHanSansSC-Regular;
    font-size: 14px;
    color: #000000;
    cursor: pointer;
  }
  .li:first-child {
    margin: 0;
  }
  .active {
    color: #0C59EF;
    border: 1px solid #0C59EF;
  }
}
.more {
  padding: 96px 0 120px 0;
  button {
    height: 25px;
    line-height: 25px;
    font-family: SourceHanSansSC-Medium;
    font-size: 18px;
    color: #666666;
    background: none;
    cursor: pointer;
    position: relative;
    width: 105px;
    text-align: left;
  }
  i {
    color: #979797;
    position: absolute;
    top: 3px;
  }
  .i1 {
    right: 14px;
  }
  .i2 {
    opacity: .6;
    right: 7px;
  }
  .i3 {
    opacity: .4;
    right: 0;
  }
  button:hover {
    color: #0C59EF;
    i {
      color: #0C59EF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cooperation.vue